import { render, staticRenderFns } from "./PaymentResDpo.vue?vue&type=template&id=a178cd40&scoped=true&"
import script from "./PaymentResDpo.vue?vue&type=script&lang=js&"
export * from "./PaymentResDpo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a178cd40",
  null
  
)

export default component.exports